import { withReset } from "@angular-architects/ngrx-toolkit";
import { signalStore, withState } from "@ngrx/signals";

import type { Accounts } from "../api/local-144/models/accounts";
import type { ServerState } from "../api/local-144/models/server-state";
import type { TenantContextResponse } from "../api/local-144/models/tenant-context-response";
import { withTreeShakeableDevTools } from "../common/store/store-features";
import { withLoadingAndError } from "../common/store/with-loading-and-error.store";
import { withSetStateMethods } from "../common/store/with-set-state-methods.store";

export interface AppState {
    serverState: ServerState | null;
    tenantBranding: Pick<TenantContextResponse, "faviconUrl" | "logoUrl" | "name"> | null;
    privacyPolicyHtml: string | null;
    currentAccount: Accounts | null;
}

const initialState: AppState = {
    serverState: null,
    tenantBranding: null,
    privacyPolicyHtml: null,
    currentAccount: null
};

export const AppStore = signalStore(
    {
        providedIn: "root"
    },
    withState(initialState),
    withLoadingAndError("AppStore"),
    withReset(),
    withSetStateMethods("AppStore", initialState),
    withTreeShakeableDevTools("app")
);
